import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements AfterViewInit {
  public today = moment();
  public selectedDate: Moment;

  @Input() dateFilter: (date: Moment) => boolean;
  @Output() dateSelect = new EventEmitter<Moment>();
  @Output() monthChange = new EventEmitter<Moment>();

  private currentMonth = moment(this.today).startOf('month');

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.setupOnNavigatedEvents();
  }

  // This method is a workaround for the fact that mat-calendar doesn’t
  // tell when the user navigates to another month. 🤷🏻‍♂️
  private setupOnNavigatedEvents() {
    const calendarElement = this.elementRef.nativeElement;

    calendarElement.querySelector('.mat-calendar-next-button').addEventListener('click', () => {
      this.goToMonth('next');
    });

    calendarElement.querySelector('.mat-calendar-previous-button').addEventListener('click', () => {
      this.goToMonth('prev');
    });
  }

  private goToMonth(which: 'prev' | 'next'): void {
    const operator = which === 'next' ? 'add' : 'subtract';
    const newMonth = this.currentMonth.clone()[operator](1, 'month');

    this.currentMonth = newMonth;
    this.monthChange.next(newMonth);
  }

  update() {
    // This is a lil hack to force mat-calendar to re-render itself.
    this.dateFilter = this.dateFilter.bind(this);
  }
}
